import { Component, Input, output, inject } from '@angular/core';
import { SphereNotification } from '../+state/notifications/notification.reducer';
import { NotificationHelperService } from '../notification/notification-helper.service';
import { SphereDateService } from '../../settings/services/sphere-date.service';
import { formatDistanceToNow } from 'date-fns';
import { UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressBar } from '@angular/material/progress-bar';
import { PulsingIndicatorComponent } from '../../components/pulsing-indicator/pulsing-indicator.component';

@Component({
    selector: 'sphere-shell-notification-center-item',
    templateUrl: './notification-center-item.component.html',
    styleUrls: ['./notification-center-item.component.scss'],
    imports: [MatIcon, MatTooltip, MatProgressBar, PulsingIndicatorComponent, UpperCasePipe]
})
export class NotificationCenterItemComponent {
    private helper = inject(NotificationHelperService);
    private date = inject(SphereDateService);

    @Input() notification!: SphereNotification;
    public readonly setReadStatus = output<boolean>();

    get fromNow(): string {
        return formatDistanceToNow(this.notification.timestamp, { addSuffix: true, includeSeconds: true });
    }

    get formattedTimestamp(): string {
        return this.date.dateFnsFormat(this.notification.timestamp, 'datetime');
    }

    get contextIcon(): string {
        return this.helper.getContextIcon(this.notification.context);
    }

    get contextClass(): string {
        return this.helper.getContextClass(this.notification.context);
    }

    get isInProgress(): boolean {
        return this.helper.isInProgress(this.notification.context);
    }
}
